'use strict';

var _ = require('lodash');
var DateRangeChartDirective = function DateRangeChartDirective(Chart, Viewport) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/date-range-chart.html'),
    controller: 'DateRangeChartController',
    scope: {
      mode: '@',
      screen: '@',
      screenState: '=',
      isCollapsible: '=',
      isChartVisible: '=?',
      isModeVisible: '=',
      listenedBrushNames: '=?',
      sendDataUpdates: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement, scope.viewportFormatters);
      scope.searchCriteriaChanged = false;
      scope.renderChartDataPresent = function (data, selectionSize) {
        chart.withMetric(scope.screenState.metric);
        if (scope.isChartVisible) {
          chart.render(data);
        } else if (data) {
          chart.data = data;
        }
        viewport.render(data, selectionSize, chart.getMaxRangeSize());
      };
      scope.setInitialSelection = function (range, silent) {
        chart.setInitialSelection(range, silent);
      };
      scope.isNoBarSelected = function () {
        return _.chain(chartElement.find('.group-data').find('.groups').find('.stack')).map('classList').filter(function (list) {
          return _.includes(list, 'selected');
        }).isEmpty().value();
      };
      scope.toggleChartVisibility = function () {
        scope.isChartVisible = !scope.isChartVisible;
        if (scope.isChartVisible) {
          setTimeout(scope.renderChartDataPresent, 0);
        }
      };
      scope.$watch('isChartVisible', function (newValue, oldValue) {
        if (oldValue !== newValue && newValue === true) {
          setTimeout(scope.renderChartDataPresent, 0);
        }
      });

      // brush change in the main chart needs to be reflected in the viewport on the fly (gray out unselected bars)
      chart.on('rangechange', function (ranges) {
        if (scope.isChartVisible) {
          viewport.onMainChartBrushChange(ranges);
        }
      });

      // update thematic charts and a grid based on the main chart selection
      chart.on('rangechangeend', function (ranges, silent) {
        if (scope.isChartVisible) {
          scope.emitBrushFilter(ranges, silent);
        }
      });
      chart.on('maxvisiblerangechange', function (max) {
        viewport.setBrushMaxSize(max);
      });

      // brush change in the viewport chart affects what's visible in the main chart
      viewport.on('rangechange', function (range) {
        if (scope.isChartVisible) {
          chart.domainChange(range);
        }
      });

      //reset chart with the new data
      scope.$on('search-criteria:searchChangeEvent', function () {
        if (scope.screenState.flightAnalysisMode && scope.screenState.flightAnalysisMode.visible || !scope.screenState.flightAnalysisMode) {
          scope.initChart();
        }
      });
      function reactForBrush(brushFilter) {
        return brushFilter.reset || Array.isArray(scope.listenedBrushNames) && scope.listenedBrushNames.indexOf(brushFilter.filterType) !== -1 || !Array.isArray(scope.listenedBrushNames) && brushFilter.filterType !== 'dateRange';
      }

      // update the main chart based on the thematic chart selection
      scope.$on('brush-filter:filterApplied', function (event, brushFilter) {
        if (reactForBrush(brushFilter)) {
          scope.redrawChartWithNewFilter();
        }
      });
      scope.$watchGroup(['screenState.metric', 'screenState.selectedReference', 'screenState.dataRepresentation', 'screenState.dimension'], function () {
        scope.keepInSync();
        scope.redrawChartWithNewFilter();
      });
      scope.$on('brush-filter:resetCharts', function () {
        scope.resetBrushSelection();
        viewport.resetBrush();
      });
      scope.$on(scope.screen + ':scenariosChanged', function () {
        scope.redrawChartWithNewFilter();
      });
      scope.resetViewportSelection = function (data, selectionSize) {
        viewport.render(data, selectionSize, chart.getMaxRangeSize());
      };
      scope.resetBrushSelection = function () {
        chart.resetBrushSelection();
      };
      scope.$watch('isModeVisible', function (newValue, oldValue) {
        if (newValue === true && oldValue === false && (scope.isNoBarSelected() || scope.searchCriteriaChanged)) {
          scope.initChart();
          scope.searchCriteriaChanged = false;
        }
      });
      scope.$watch('screenState.filters', function () {
        scope.searchCriteriaChanged = scope.screenState.flightManagementMode && scope.screenState.flightManagementMode.visible;
      }, true);
      scope.$on(scope.screen + '-' + scope.mode + '-dateRange:resetWithDataRetriever', function () {
        scope.initChart();
      });
      scope.$emit('chart:init', scope.screen + '-' + scope.mode + '-dateRange');
      scope.$watchGroup(['screenState.isFlightAnalysisGridExpanded', 'screenState.isMarketAnalysisGridExpanded', 'screenState.isMarketProductGridExpanded', 'screenState.isServiceGridExpanded'], function (currentExpansionState, prevExpansionState) {
        scope.reloadChartsDuringMaximize(currentExpansionState, prevExpansionState, chart.getSelection());
      });
    }
  };
};
DateRangeChartDirective.$inject = ['DateRangeChart', 'DateRangeChartViewport'];
module.exports = DateRangeChartDirective;